<template>
	<div>
        <div id="cookies-notice-wrapper" class="cookies-notice" style="display: none;" role="dialog">
          <div class="container">
            <section class="cookies-notice__intro">
				<h1>Our Cookies</h1>
				<p>We use cookies to improve your experience on our website, measure performance, tailor the marketing you see and show you personalised content. By clicking ‘Allow All’, you consent to the storing of all cookies on your device. You can see the cookies we use and <a href="https://www.fmconway.co.uk/files/library/files/Footer%20Links/Website%20Cookie%20Policy.pdf">view our policy here</a>. You can also manage what cookies we place by clicking ‘manage cookies’</p>
				<p>
					<a role="button" class="cookies-notice__btn cookies-notice__btn--white cookies-notice-display">Manage Cookies</a>
					<a role="button" class="cookies-notice__btn cookies-notice__btn--primary" id="cookies-notice-allow">Allow All</a>
				</p>
              </section>
          </div>
        </div>
        <div id="cookies-notice-manage" class="cookies-notice" style="display: none;" role="dialog">
          <div class="container">
              <h1 class="cookies-notice__manage__heading">Manage Cookies</h1>
              <div class="cookies-notice__content">
                <section class="cookies-notice__necesary">
                    <h2>Necessary Cookies</h2>
                    <p>We use necessary cookies to make our site work.</p>
                </section>
                <section class="cookies-notice__analytics">
                    <div class="cookies-notice__analytics__heading">
                        <h2>Marketing &amp; Analytics Cookies </h2>
                        <label class="cookies-notice__analytics__control">
                            <input class="cookies-notice__analytics__control__state" id="analytics-toggle" type="checkbox" />
                            <span class="cookies-notice__analytics__control__status">
                                <span role="button" class="cookies-notice__analytics__control__status__label cookies-notice__analytics__control__status__label--off">Off</span>
                                <span role="button" class="cookies-notice__analytics__control__status__label cookies-notice__analytics__control__status__label--on">On</span>
                            </span>
                        </label>
                    </div>
                    <div class="cookies-notice__analytics__content">
                        <p>We would like your consent to collect this data to help us measure website performance, tailor the marketing you see and show you personalised content.</p>
                    </div>
                </section>
                <section class="cookies-notice__remove">
                    <button class="cookies-notice__btn cookies-notice__btn--primary" id="cookies-notice-close">Confirm my preference</button>
                </section>
              </div>
          </div>
        </div>
	</div>
</template>
<script>
export default {
	props: [
		'user',
	],
	mounted() {
		'use strict';
		const self = this;

		/*document.addEventListener('DOMContentLoaded',*/ (function () {
			document.querySelector('#cookies-notice-allow').addEventListener('click', function () {
				document.querySelector('#analytics-toggle').checked = true;
				analyticsEnable();
				cookiesHide();
			});
			const displayBtns = document.querySelectorAll('.cookies-notice-display');
			displayBtns.forEach((displayBtn) => {
				displayBtn.addEventListener('click', displayBtnHandler);
			});
			cookiesInit();

			document.querySelector('#cookies-notice-close').addEventListener('click', function () {
				if(document.querySelector('#analytics-toggle').checked) {
					analyticsEnable();
				}
				else {
					analyticsDisable();
				}

				cookiesHide();
			});
		})();

		function displayBtnHandler(evnt) {
			evnt.preventDefault();
			document.querySelector('#cookies-notice-wrapper').style.display = 'none';
			document.querySelector('#cookies-notice-manage').style.display = 'block';
		}

		function cookiesHide () {
			document.querySelector('#cookies-notice-manage').style.display = 'none';
			document.querySelector('#cookies-notice-wrapper').style.display = 'none';
		}

		function cookiesInit () {
            const cookie = window.localStorage.getItem("cookies-status");

			if (cookie === null) {
				const displayBtns = document.querySelectorAll('.cookies-notice-display');
				if(displayBtns.length <= 1)
                {
					document.querySelector('#cookies-notice-wrapper').style.display = 'block';
                }
			}
            else if (cookie === 'enabled') {
                document.querySelector('#analytics-toggle').checked = true;
                analyticsFetch();
            }
		}

        function analyticsFetch() {
			const body = document.querySelector('body');
			const req = new XMLHttpRequest();
			req.addEventListener('load', function(evnt) {
				//console.log(evnt);
				const responseText = evnt.target.responseText;
				const data = JSON.parse(responseText);
				const head = document.querySelector('head');

				const headHolder = document.createElement("div");
				headHolder.innerHTML += data.analytics_head_html;
				nodeScriptReplace(headHolder);
				headHolder.childNodes.forEach((node) => {
					head.append(node);
				});

				const bodyHolder = document.createElement("div");
				bodyHolder.innerHTML += data.analytics_html;
				nodeScriptReplace(bodyHolder);
				bodyHolder.childNodes.forEach((node) => {
					body.append(node);
				});
			});
			req.addEventListener('error', () => {
				console.error('Failed to load analytics');
			});
			const uri = '/tracking'+(self.user === 'true' ? '?user=true' : '?user=false');
			req.open("GET", uri);
			req.send();

			function nodeScriptReplace(node) {
				if ( node.tagName === 'SCRIPT' ) {
					node.parentNode.replaceChild( nodeScriptClone(node) , node );
				}
				else {
					var i = -1;
					const children = node.childNodes;
					while ( ++i < children.length ) {
						nodeScriptReplace( children[i] );
					}
				}

				return node;
			}
			function nodeScriptClone(node){
				const script  = document.createElement("script");
				script.text = node.innerHTML;

				var i = -1, attr;
				const attrs = node.attributes;
				while ( ++i < attrs.length ) {
					script.setAttribute( (attr = attrs[i]).name, attr.value );
				}
				return script;
			}
		}

		function analyticsEnable() {
            window.localStorage.setItem("cookies-status", "enabled");
			analyticsFetch();

            // Create the event.
            const event = document.createEvent('Event');
            // Define that the event name is 'analyticsEnable'.
            event.initEvent('analyticsEnable', true, true);
            // target can be any Element or other EventTarget.
            window.dispatchEvent(event);
		}

		function analyticsDisable() {
			window.localStorage.setItem("cookies-status", "disabled");
			const token = document.head.querySelector('meta[name="csrf-token"]');
			const post = '_token='+ encodeURIComponent(token.content);
			const req = new XMLHttpRequest();
			req.addEventListener('load', (evnt) => {
				console.info('Disabled analytics');
			});
			req.addEventListener('error', () => {
				console.error('Failed disable analytics');
			});
			const uri_segment = '/';
			req.open('POST', uri_segment+'tracking/disable');
			req.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
			req.setRequestHeader('X-CSRF-TOKEN', token.content);
			req.send(post);
		}

        function analyticsDismiss() {
            window.localStorage.setItem("cookies-status", "dismissed");
		}
	}, // mounted()
}
</script>